import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { LoadingSpinner } from '../LoadingSpinner';

export const OrderLookupModal = ({ formik, show, handleClose, handleLookupKeyDown, lookupPackage, fetchLoading }) => {
    return (
        <Modal show={show} onHide={handleClose} backdrop='static'>
            <Modal.Header closeButton>
                <Modal.Title>Lookup</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Enter the lookup value for the package(s) you wish to import.</p>
                <Form.Group className='form-group'>
                    <Form.Label>Lookup:</Form.Label>
                    <Form.Control
                        name='orderNum'
                        type='text'
                        autoFocus
                        onKeyDown={handleLookupKeyDown}
                        {...formik.getFieldProps('orderNum')}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button className='purple-btn' onClick={lookupPackage} disabled={fetchLoading}>
                    {fetchLoading ? <LoadingSpinner /> : 'OK'}
                </Button>
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
